import { CSSProperties, FunctionComponent } from 'react'
import { Spinner } from 'react-bootstrap'

interface SpinnerAbsoluteProps {
  isLoading: boolean
}

const SpinnerAbsolute: FunctionComponent<SpinnerAbsoluteProps> = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div
          style={{ '--bs-bg-opacity': '0.7' } as CSSProperties}
          className="p-4 w-100 start-0 end-0 h-100 align-items-center position-absolute d-flex justify-content-center bg-white z-3"
        >
          <Spinner variant="secondary" animation="border" />
        </div>
      )}
    </>
  )
}

export default SpinnerAbsolute
